/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type AgentFilterStatusItem =
  (typeof AgentFilterStatusItem)[keyof typeof AgentFilterStatusItem];

export const AgentFilterStatusItem = {
  IDEA_PHASE: "IDEA_PHASE",
  ADOPTED: "ADOPTED",
  POSTPONED: "POSTPONED",
  STARTED: "STARTED",
  SUGGESTION: "SUGGESTION",
  CANCELLED: "CANCELLED",
  UNKNOWN: "UNKNOWN",
} as const;
